/**
 * Built-in character sheet templates shipped with roll1.
 * Thin barrel — re-exports from system-specific modules.
 *
 * These are always available (builtIn: true) and not serialized into SessionState.
 */

import type { SheetTemplate } from './types.js';

// D&D 5e
export { DND5E_TEMPLATE_ID, dnd5eTemplate } from './systems/dnd5e/template.js';

// Pathfinder 2e
export { PF2E_TEMPLATE_ID, pf2eTemplate } from './systems/pf2e/template.js';

// Re-import for local use in utility functions
import { dnd5eTemplate } from './systems/dnd5e/template.js';
import { pf2eTemplate } from './systems/pf2e/template.js';

/** All built-in templates. */
export const builtinTemplates: SheetTemplate[] = [dnd5eTemplate, pf2eTemplate];

/** Get all available templates (built-in + user-created). */
export function getAllTemplates(userTemplates: SheetTemplate[]): SheetTemplate[] {
  return [...builtinTemplates, ...userTemplates];
}

/** Find a template by ID (built-in or user-created). */
export function findTemplate(templateId: string, userTemplates: SheetTemplate[]): SheetTemplate | undefined {
  return builtinTemplates.find(t => t.id === templateId) ?? userTemplates.find(t => t.id === templateId);
}
